export default __webpack_public_path__ + "static/media/elementos-bd-ilustracion-stf.fa1b6edb.svg";